import React from 'react';

import ButtonComponent from '@/components/common-components/ButtonComponent/ButtonComponent';
import ModalCommonButtonsContainer from '@/components/common-components/ModalComponent/ModalCommonButtonsContainer/ModalCommonButtonsContainer';
import ArrowRight from '@/components/Icons/icons/ArrowRight';

interface Props {
  currentStep: number;
  totalSteps: number;
  handleNextStep: () => void;
  handlePreviousStep: () => void;
}

const OnboardingModalButtons = ({ currentStep, totalSteps, handleNextStep, handlePreviousStep }: Props) => {
  if (currentStep === 1) {
    return (
      <ButtonComponent className="onboarding-modal-start-tour-button" onClick={handleNextStep}>
        Start Tour
      </ButtonComponent>
    );
  }

  return (
    <ModalCommonButtonsContainer
      cancelButtonText="Go Back"
      submitButtonText={
        currentStep === totalSteps ? (
          'Finish Tour'
        ) : (
          <>
            Next <ArrowRight color="white" />
          </>
        )
      }
      onClose={handlePreviousStep}
      onSave={handleNextStep}
    />
  );
};

export default OnboardingModalButtons;
